import { Router } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
import { Seguimiento_certificadoComponent } from '../seguimiento_certificado/seguimiento_certificado.component';
import { HomeComponent } from '../home/home.component';
var AuxUrlcertComponent = /** @class */ (function () {
    function AuxUrlcertComponent(dialog, _router, _snackBar) {
        this.dialog = dialog;
        this._router = _router;
        this._snackBar = _snackBar;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
        this.filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
        this.seguimientoCertificados = GLOBAL.seguimientoCertificados;
    }
    AuxUrlcertComponent.prototype.sign = function (tipo) {
        this.dialog.open(HomeComponent, {
            data: {
                url: tipo
            }
        });
        if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
            this.dialog.closeAll();
            if (tipo == 'seg-certificados') {
                this._router.navigate(["/seguimiento_certificados"]);
            }
            if (tipo == 'val-certificado') {
                this._router.navigate(["/validar-certificado"]);
            }
        }
        else {
            if (tipo == 'seg-certificados') {
                this._router.navigate(["/seguimiento_certificados"]);
            }
            if (tipo == 'val-certificado') {
                this._router.navigate(["/validar-certificado"]);
            }
        }
        this.dialog.closeAll();
    };
    AuxUrlcertComponent.prototype.solicitud_certificado = function () {
        console.log("solicitud_certificado()");
        this._router.navigate(["/certificados"]);
    };
    AuxUrlcertComponent.prototype.seguimiento = function () {
        this.dialog.open(Seguimiento_certificadoComponent);
    };
    AuxUrlcertComponent.prototype.fireDialog = function () {
        var _this = this;
        swal({
            type: 'warning',
            title: 'Atención!',
            text: "<p style:\"color: red;font-weight: 900;font-size: 27px;\">Sitio en Mantenci\u00F3n.</p>\n            <p style:\"color: black;font-size: 19px;font-weight: 600;\">Consultas llamar al fono 224327736.</p>",
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            onClose: function () {
                _this.dialog.closeAll();
            }
        }).then(function () {
        }, function (dismiss) {
            if (dismiss === 'timer') {
                _this.dialog.closeAll();
            }
        });
    };
    return AuxUrlcertComponent;
}());
export { AuxUrlcertComponent };
